import moment from "moment";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useParams, useLocation, Link, useNavigate } from "react-router-dom";
import { AxiosInstance } from "../../../../axios";
import { ImageUrlPrefix } from "../../../../labels";
import Swal from "sweetalert2";
import { Download } from "@mui/icons-material";
import ModelComForP from "../../../../pages/ModelComForP";
import Loader from "../../Loader";
import styles from "./UploadQuestionFile.module.css";
import { Box, LinearProgress } from "@mui/material";
import ProgressLoader from "./ProgressLoader";
export default function UploadQuestionFile() {
  const navigate = useNavigate();
  const location = useLocation();
  // console.log(location);
  const { id, status } = location.state;

  // id 1 - obj 0 - desc
  const { type } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});
  console.log(error, "errorerrorerror");

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot available in session storage");
  }

  useEffect(() => {
    FindByid(id);
  }, []);

  const [fdata, setFdata] = useState({
    title: "",
    sDate: "",
    startTime: "",
    endTime: "",
    subject: "",
    staff_name: "",
    description: "",
    batchName: "",
    category: "",
    course: "",
    que_status: "",
    classMode: "",
    medium: "",
    location: "",
    teams_url: "",
    batch_id: "",
    event_id: "",
    test_num: "",
    test_topic: "",
    tol_mark: "",
    no_ques: "",
    qpath: null,
    cut_off: "",
    method_of_test: "",
    questionPath: null,
    question_paper_original_path: null,
    AnswerBookletPath: null,
    answer_booklet_original_path: null,
    questionFrameSetPath: null,
    question_frame_original_path: null,
    AnswerKeyPath: null,
    answer_key_original_path: null,
    doubleEvaluation: "",
    original_que_paper_filepath: null,
  });
  const [studResponse, setStudResponse] = useState([]);
  console.log(studResponse, "studResponse");

  const [oth_app_batch, setOth_app_batch] = useState([]);

  const [subTopic, setSubTopic] = useState([]);

  const [swalMsg, setSwalMsg] = useState({
    show: false,
    status: "",
    message: "",
    title: "",
    BottomOkBtn: "",
    BottomCancelBtn: "",
    BottomOkClose: "",
  });
  const validateUploadFile = (data, typee) => {
    const errors = {};

    if (
      (data.qpath === "" && typee === "1") ||
      (data.qpath === null && typee === "1")
    ) {
      errors.qpath = "Please Upload csv file";
    }
    if (!data.cut_off && typee === "1") {
      errors.cut_off = "Please enter cut off";
    }
    if (
      data.questionPath === "" ||
      (data.questionPath === null && typee === "0")
    ) {
      errors.questionPath = "Please Upload pdf file";
    }

    if (
      data.AnswerBookletPath === "" ||
      (data.AnswerBookletPath === null && typee === "0")
    ) {
      errors.AnswerBookletPath = "Please Upload pdf file";
    }
    if (
      data.AnswerKeyPath === "" ||
      (data.AnswerKeyPath === null && typee === "0")
    ) {
      errors.AnswerKeyPath = "Please Upload pdf file";
    }
    if (data.cut_off === "" && typee === "0") {
      errors.cut_off = "Please enter cut off";
    }
    if (data.doubleEvaluation === "" && typee === "0") {
      errors.doubleEvaluation = "Please select Evaluation";
    }
    return errors;
  };

  const navigateToPreviousScreen = () => {
    navigate(-1); // Navigate back by one step in the history
  };

  const FindByid = (id) => {
    if (id) {
      setIsLoading(true);
      AxiosInstance.post("api/event/findById", {
        id: parseInt(id),
        event_type: 1,
      })
        .then((res) => {
          if (res.data.status === true) {
            setIsLoading(false);
            let el = res.data.data;
            setStudResponse(el);
            console.log(el, "elelelelelelel");

            setFdata((prevFdata) => ({
              ...prevFdata,
              title: el.name,
              sDate:
                el.start_date !== null
                  ? moment(el.start_date).format("YYYY-MM-DD")
                  : "",
              que_status: el.que_status,
              startTime: el.start_time,
              endTime: el.end_time,
              subject: el.subject,
              method_of_test: el.method_of_test,
              staff_name: el.staff_name,
              description: el.description,
              batchName: el.batch_name,
              category: el.category,
              course: el.category_class,
              classMode: el.class_mode,
              medium: el.medium,
              location: el.location,
              teams_url: el.teams_url,
              batch_id: el.batch_id,
              event_id: el.id,
              test_num: el.test_no,
              test_topic: el.test_topic,
              tol_mark: el.tot_marks,
              cut_off: el.cut_off,
              no_ques: el.no_of_questions,
              qpath: null,
              questionPath:
                el.que_paper_filepath !== null ? el.que_paper_filepath : null,
              original_que_paper_filepath: el.original_que_paper_filepath,
              question_paper_original_path: el.original_que_paper_filepath,
              AnswerBookletPath:
                el.answer_booklet_path !== null ? el.answer_booklet_path : null,
              // original_que_paper_filepath: el.original_que_paper_filepath,
              answer_booklet_original_path: el.answer_booklet_original_path,
              AnswerKeyPath:
                el.answer_key_path !== null ? el.answer_key_path : null,
              answer_key_original_path: el.answer_key_original_path,
              questionFrameSetPath:
                el.question_frame_path !== null ? el.question_frame_path : null,
              question_frame_original_path: el.question_frame_original_path,
              doubleEvaluation: el.double_evaluation,
            }));

            const subTopics =
              el.subject_test_topics && el.subject_test_topics.length > 0
                ? el.subject_test_topics
                : [];

            setSubTopic(subTopics);

            const OtherApplicableBatches =
              el.oth_app_batch && el.oth_app_batch.length > 0
                ? el.oth_app_batch
                : [];

            setOth_app_batch(OtherApplicableBatches);
          } else {
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          return error;
        });
    }
  };

  const handleUpload_objective = (e) => {
    const errors = validateUploadFile(fdata, type);

    if (Object.keys(errors).length === 0) {
      try {
        const df = {
          file_path: fdata.qpath,
          original_que_paper_filepath: fdata.original_que_paper_filepath,
          event_id: fdata.event_id,
          cut_off: fdata.cut_off,
          updated_by: userid,
        };
        // console.log(df, "df");
        AxiosInstance.post("api/test/filePath/update", df)
          .then((response) => {
            if (response.data.status === true) {
              AxiosInstance.post("/api/test/questionUpload", {
                batch_id: fdata.batch_id,
                que_paper_filepath: response.data.data.file_path,
                event_id: response.data.data.event_id,
                no_of_questions: fdata.no_ques,
                created_by: response.data.data.updated_by,
                updated_by: response.data.data.updated_by,
                updated_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
              })
                .then((response) => {
                  if (response.data.status === true) {
                    Swal.fire({
                      title: "Success",
                      text: response.data.message,
                      icon: "Success",
                      confirmButtonText: "Ok",
                    });
                    navigateToPreviousScreen();
                  } else {
                    Swal.fire({
                      title: "Warning",
                      text: response.data.message,
                      icon: "Warning",
                      confirmButtonText: "Ok",
                    });
                  }
                })
                .catch((error) => {
                  return error;
                });
            }
          })
          .catch((error) => {
            return error;
          });
      } catch (error) {
        console.log(error);
      }
    } else {
      setError(errors);
    }
  };

  const handleUpload = (e) => {
    const errors = validateUploadFile(fdata, type);
    if (Object.keys(errors).length === 0) {
      const updateEvent = {
        event_id: fdata.event_id,
        question_paper_path: fdata.questionPath,
        question_paper_original_path: fdata.question_paper_original_path,
        answer_booklet_path: fdata.AnswerBookletPath,
        answer_booklet_original_path: fdata.answer_booklet_original_path,
        // question_frame_path:"uploads\\question_frame_set\\question_frame_set1726634856174.xlsx",
        question_frame_path: fdata.questionFrameSetPath,
        // question_frame_original_path:"Admin WorkFlow in Descriptive (Test Model).xlsx",
        question_frame_original_path: fdata.question_frame_original_path,
        created_by: userid,
        answer_key_path: fdata.AnswerKeyPath,
        answer_key_original_path: fdata.answer_key_original_path,
        double_evaluation: fdata.doubleEvaluation, // 0 : single evaluation 1: double evaluation
        cut_off: fdata.cut_off,
      };
      AxiosInstance.post("api/test/descriptive/questions_save", updateEvent)
        .then((res) => {
          if (res.data.status === true) {
            navigateToPreviousScreen();
            Swal.fire({
              title: "Success",
              text: res.data.message,
              icon: "success",
              confirmButtonText: "Ok",
            });
          }
        })
        .catch((error) => {
          return error;
        });
    } else {
      setError(errors);
    }
  };
  const handlechange = (e) => {
    const { name, value, files } = e.target;

    if (name === "qpath" && files && files.length > 0) {
      const question_bank = files[0];
      setFdata((prevState) => ({
        ...prevState,
        qpath: null,
        original_que_paper_filepath: null,
      }));
      if (
        files[0].type == "text/csv" ||
        files[0].type == "application/vnd.ms-excel"
      ) {
        if (files[0].size < 10 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("question_bank", question_bank);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setFdata((prevState) => ({
                ...prevState,
                qpath: res.data.path,
                original_que_paper_filepath: res.data.originalname,
              }));
              setError({
                ...error,
                qpath: "",
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          let err = "File size must be less than 10MB.";
          setError({
            ...error,
            qpath: err,
          });
          setFdata((prevState) => ({
            ...prevState,
            qpath: null,
            original_que_paper_filepath: null,
          }));
        }
      } else {
        let err = "csv files only allowed";
        setError({
          ...error,
          qpath: err,
        });
        setFdata((prevState) => ({
          ...prevState,
          qpath: null,
          original_que_paper_filepath: null,
        }));
      }
    } else {
      setFdata((prevFields) => ({
        ...prevFields,
        [name]: value,
      }));
      setError({
        ...error,
        [name]: "",
      });
    }
  };
  const [progress, setProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  // To control loader visibility
  // Descriptive Upload Question Paper
  const handleFileChange = (e) => {
    // console.log(e, "ee");
    const { name, value, files } = e.target;
    if (name === "questionPath") {
      if (files && files.length > 0) {
        console.log(value, files);
        const question_paper = files[0];
        setFdata((prevState) => ({
          ...prevState,
          questionPath: null,
          question_paper_original_path: null,
        }));
        if (question_paper.type === "application/pdf") {
          if (question_paper.size) {
            // Check file size < 10MB
            const formData = new FormData();
            formData.append("question_paper", question_paper);

            setIsUploading(true); // Start uploading
            AxiosInstance.post("api/upload/", formData, {
              onUploadProgress: (progressEvent) => {
                const progress = Math.round(
                  (progressEvent.loaded / progressEvent.total) * 100
                );
                setProgress(progress); // Update progress bar
              },
              onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
                setProgress(percentCompleted); // Update progress state
              },
            })
              .then((res) => {
                setFdata((prevState) => ({
                  ...prevState,
                  questionPath: res.data.path,
                  question_paper_original_path: res.data.originalname,
                }));
                setError((prevError) => ({ ...prevError, questionPath: "" }));
              })
              .catch((error) => {
                setError((prevError) => ({
                  ...prevError,
                  questionPath: "Upload failed.",
                }));
              })
              .finally(() => {
                setIsUploading(false); // Stop uploading after completion
                setProgress(0); // Reset progress bar
              });
          } else {
            setError((prevError) => ({
              ...prevError,
              questionPath: "File size must be less than 10MB.",
            }));
            setFdata((prevState) => ({
              ...prevState,
              questionPath: null,
              question_paper_original_path: null,
            }));
          }
        } else {
          setError((prevError) => ({
            ...prevError,
            questionPath: "Only PDF files are allowed.",
          }));
          setFdata((prevState) => ({
            ...prevState,
            questionPath: null,
            question_paper_original_path: null,
          }));
        }
      } else {
        setFdata((prevState) => ({
          ...prevState,
          questionPath: null,
          question_paper_original_path: null,
        }));
      }
    } else if (name === "AnswerBookletPath") {
      if (files && files.length > 0) {
        const answer_booklet = files[0];
        setFdata((prevState) => ({
          ...prevState,
          AnswerBookletPath: null,
          answer_booklet_original_path: null,
        }));
        if (
          files[0].type === "text/pdf" ||
          files[0].type === "application/pdf"
        ) {
          if (files[0].size < 10 * 1024 * 1024) {
            // Check file size < 10MB
            const formData = new FormData();
            formData.append("answer_booklet", files[0]); // Use files[0] as the file input

            setIsUploading(true); // Start uploading
            AxiosInstance.post("api/upload/", formData, {
              onUploadProgress: (progressEvent) => {
                const progress = Math.round(
                  (progressEvent.loaded / progressEvent.total) * 100
                );
                setProgress(progress); // Update progress bar
              },
            })
              .then((res) => {
                setFdata((prevState) => ({
                  ...prevState,
                  AnswerBookletPath: res.data.path,
                  answer_booklet_original_path: res.data.originalname,
                }));
                setError((prevError) => ({
                  ...prevError,
                  AnswerBookletPath: "",
                }));
              })
              .catch((error) => {
                setError((prevError) => ({
                  ...prevError,
                  AnswerBookletPath: "Upload failed.",
                }));
              })
              .finally(() => {
                setIsUploading(false); // Stop uploading after completion
                setProgress(0); // Reset progress bar
              });
          } else {
            setError((prevError) => ({
              ...prevError,
              AnswerBookletPath: "File size must be less than 10MB.",
            }));
            setFdata((prevState) => ({
              ...prevState,
              AnswerBookletPath: null,
              answer_booklet_original_path: null,
            }));
          }
        } else {
          setError((prevError) => ({
            ...prevError,
            AnswerBookletPath: "Invalid file type. Only PDF files are allowed.",
          }));
          setFdata((prevState) => ({
            ...prevState,
            AnswerBookletPath: null,
            answer_booklet_original_path: null,
          }));
        }
      } else {
        setFdata((prevState) => ({
          ...prevState,
          AnswerBookletPath: null,
          answer_booklet_original_path: null,
        }));
      }
    } else if (name === "AnswerKeyPath") {
      if (files && files.length > 0) {
        const answer_key = files[0];
        setFdata((prevState) => ({
          ...prevState,
          AnswerKeyPath: null,
          answer_key_original_path: null,
        }));
        if (files[0].type == "text/pdf" || files[0].type == "application/pdf") {
          if (files[0].size < 10 * 1024 * 1024) {
            const formData = new FormData();
            formData.append("answer_key", answer_key);
            AxiosInstance.post("api/upload/", formData)
              .then((res) => {
                setFdata((prevState) => ({
                  ...prevState,
                  AnswerKeyPath: res.data.path,
                  answer_key_original_path: res.data.originalname,
                }));
                setError({
                  ...error,
                  AnswerKeyPath: "",
                });
              })
              .catch((error) => {
                return error;
              });
          } else {
            let err = "File size must be less than 10MB.";
            setError({
              ...error,
              AnswerKeyPath: err,
            });
            setFdata((prevState) => ({
              ...prevState,
              AnswerKeyPath: null,
              answer_key_original_path: null,
            }));
          }
        } else {
          let err = "pdf files only allowed";
          setError({
            ...error,
            AnswerKeyPath: err,
          });
          setFdata((prevState) => ({
            ...prevState,
            AnswerKeyPath: null,
            answer_key_original_path: null,
          }));
        }
      } else {
        setFdata((prevState) => ({
          ...prevState,
          AnswerKeyPath: null,
          answer_key_original_path: null,
        }));
      }
    } else if (name === "questionFrameSetPath") {
      if (files && files.length > 0) {
        const question_frame_set = files[0];
        setFdata((prevState) => ({
          ...prevState,
          questionFrameSetPath: null,
          question_frame_original_path: null,
        }));
        // Check for valid CSV MIME types
        const allowedMimeTypes = ["text/csv", "application/vnd.ms-excel"];
        // Validate file type
        if (allowedMimeTypes.includes(files[0].type)) {
          // Validate file size (less than 10MB)
          if (files[0].size < 10 * 1024 * 1024) {
            const formData = new FormData();
            formData.append("question_frame_set", question_frame_set);

            // First API call
            AxiosInstance.post("api/upload/", formData)
              .then((res) => {
                console.log(res, "upload response");
                setFdata((prevState) => ({
                  ...prevState,
                  questionFrameSetPath: res.data.path,
                  question_frame_original_path: res.data.originalname,
                }));

                setError({
                  ...error,
                  questionFrameSetPath: "",
                });

                if (res.data.status) {
                  // Second API call
                  AxiosInstance.post("api/test/descriptive/question_upload", {
                    batch_id: fdata.batch_id,
                    event_id: fdata.event_id,
                    question_frame_path: res.data.path,
                    // created_by: res.data.data.updated_by,
                  })
                    .then((response) => {
                      console.log("Second API response:", response.data);
                    })
                    .catch((error) => {
                      console.error("Error uploading question:", error);
                    });
                }
              })
              .catch((error) => {
                console.error("Error in first API call:", error);
              });
          } else {
            let err = "File size must be less than 10MB.";
            setError({
              ...error,
              questionFrameSetPath: err,
            });
            setFdata((prevState) => ({
              ...prevState,
              questionFrameSetPath: null,
              question_frame_original_path: null,
            }));
          }
        } else {
          // Handle invalid file type (e.g., PDF or other)
          let err = " CSV files only allowed.";
          setError({
            ...error,
            questionFrameSetPath: err,
          });
          setFdata((prevState) => ({
            ...prevState,
            questionFrameSetPath: null,
            question_frame_original_path: null,
          }));
        }
      } else {
        setFdata((prevState) => ({
          ...prevState,
          questionFrameSetPath: null,
          question_frame_original_path: null,
        }));
      }
    } else {
      setFdata((prevFields) => ({
        ...prevFields,
        [name]: value,
      }));
      setError({
        ...error,
        [name]: "",
      });
    }
  };
  const handleCloseModels_Succ = () => {
    setSwalMsg({
      show: false,
      status: "",
      message: "",
      title: "",
      BottomOkClose: "",
    });

    // navigateToPreviousScreen();
  };

  const handleCloseModel = () => {
    setSwalMsg({
      show: false,
      status: "",
      message: "",
      title: "",
      BottomOkClose: "",
    });
    navigateToPreviousScreen();
  };
  // const progress =70;
  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     setProgress((oldProgress) =>
  //       oldProgress >= 100 ? 0 : oldProgress + 10
  //     );
  //   }, 1000);

  //   return () => {
  //     clearInterval(timer);
  //   };
  // }, []);
  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className="BathDet">
      <div className="row">
        <div className="col-md-12">
          {swalMsg.show === true && (
            <ModelComForP
              show={swalMsg.show}
              message={swalMsg.message}
              status={swalMsg.status}
              title={swalMsg.title}
              BottomOkBtn={swalMsg.BottomOkBtn}
              BottomCancelBtn={swalMsg.BottomCancelBtn}
              handleCloseModels={handleCloseModel}
              // handleClose_yes={handleSPayfee}
              BottomOkClose={swalMsg.BottomOkClose}
              handleCloseModels_Succ={handleCloseModels_Succ}
            />
          )}
          <section className=" StepOne">
            <div className="heading mt-3 d-flex justify-content-between ">
              <h6 className="Tit"> Upload New Question Paper</h6>
              <Link
                to="javascript:void(0)"
                onClick={navigateToPreviousScreen}
                className="CancelButton"
              >
                Back to View Test
              </Link>
              <button
                type="button"
                className="detailEventButton"
                onClick={type === "1" ? handleUpload_objective : handleUpload}
              >
                Save Question Paper
              </button>
            </div>
            <div className="row box">
              <div className="col-md-12">
                <p className="StepTitle">Test Details</p>
                <div className="row mb-3">
                  <div className="col-md-3">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted "
                      >
                        Test Name
                      </label>
                      <span className="ReviewLabel">
                        {fdata.title !== null ? fdata.title : "⎯"}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted "
                      >
                        Date
                      </label>
                      <span className="ReviewLabel">
                        {fdata.sDate !== null ? fdata.sDate : "⎯"}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted "
                      >
                        Start Time
                      </label>
                      <span className="ReviewLabel">
                        {fdata.startTime !== null
                          ? moment(fdata.startTime, "HH:mm:ss").format("h:mm A")
                          : "⎯"}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted "
                      >
                        End Time
                      </label>
                      <span className="ReviewLabel">
                        {fdata.endTime !== null
                          ? moment(fdata.endTime, "HH:mm:ss").format("h:mm A")
                          : "⎯"}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted "
                      >
                        Total Number of Questions
                      </label>
                      <span className="ReviewLabel">
                        {fdata.no_ques !== null ? fdata.no_ques : "⎯"}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted "
                      >
                        Total Marks
                      </label>
                      <span className="ReviewLabel">
                        {fdata.tol_mark !== null ? fdata.tol_mark : "⎯"}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted "
                      >
                        Batch Name
                      </label>
                      <span className="ReviewLabel">
                        {fdata.batchName !== null ? fdata.batchName : "⎯"}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted "
                      >
                        Category
                      </label>
                      <span className="ReviewLabel">
                        {fdata.category !== null ? fdata.category : "⎯"}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted "
                      >
                        Course
                      </label>
                      <span className="ReviewLabel">
                        {fdata.course !== null ? fdata.course : "⎯"}
                      </span>
                    </div>
                  </div>

                  {/* <div className="col-md-3">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted "
                      >
                        Subject
                      </label>
                      <span className="ReviewLabel">
                        {fdata.subject !== null ? fdata.subject : "⎯"}
                      </span>
                    </div>
                  </div> */}
                  <div className="col-md-3">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted "
                      >
                        Method of Test
                      </label>
                      <span className="ReviewLabel">
                        {fdata.method_of_test !== null
                          ? fdata.method_of_test === 0
                            ? "Objective"
                            : fdata.method_of_test === 1
                            ? "Descriptive"
                            : "⎯"
                          : "⎯"}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted "
                      >
                        Status
                      </label>
                      <span className="ReviewLabel">
                        <span className={`${styles.ReviewLabel}`}>
                          {fdata.que_status === 0 &&
                            "Questions Not Yet Uploaded"}
                          {fdata.que_status === 1 && "Questions Uploaded"}
                          {fdata.que_status === 2 && "Answer Sheet Uploaded"}
                          {fdata.que_status === 3 && "Assigned to Evaluators"}
                          {fdata.que_status === 4 && "Answer Sheet Evaluated"}
                          {fdata.que_status === 5 && "Results Published"}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className=" StepOne">
            <div className="row box">
              <div className="col-md-12 mb-3">
                <p className="StepTitle">Subjects and Topics</p>
                {subTopic.length > 0 &&
                  subTopic.map((onk) => {
                    return (
                      <div className="row ">
                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Subject
                            </label>
                            <span className="ReviewLabel">
                              {onk.subject_name || "-"}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-9">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Test Topics
                            </label>
                            <span className="ReviewLabel">
                              {onk.test_topics
                                .map((el) => el.test_topic)
                                .join(", ")}
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </section>

          <section className=" StepOne">
            <div className="row box">
              <div className="col-md-12">
                <p className="StepTitle">Other Applicable Batches</p>
                <div className="row mb-3 ">
                  <div className="col-md-6">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted"
                      >
                        Other Applicable Batches
                      </label>
                      {oth_app_batch.length > 0 ? (
                        <span className="ReviewLabel">
                          {oth_app_batch.map((lk, index) => (
                            <React.Fragment key={index}>
                              {index > 0 && ", "}{" "}
                              {/* Add comma and space for elements after the first one */}
                              {lk.name}({lk.section})
                            </React.Fragment>
                          ))}
                        </span>
                      ) : (
                        <span className="ReviewLabel">_</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* // Objective code */}
          {type === "1" && (
            <section className=" StepOne">
              <div className="row box">
                <div className="col-md-12">
                  <p className="StepTitle">Upload New Question Paper</p>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <div className="forms ">
                        <label htmlFor="inputName" className="form-label  ">
                          Update New Question Paper
                          {fdata.qpath !== "" && fdata.qpath !== null && (
                            <a
                              target="_blank"
                              href={`${ImageUrlPrefix}/${fdata.qpath}`}
                            >
                              <Download className="download_icon" />
                            </a>
                          )}
                        </label>
                        <div className="d-flex">
                          <div className="row">
                            <div
                              className={
                                fdata.qpath !== "" && fdata.qpath !== null
                                  ? "col-md-3 "
                                  : "col-md-12"
                              }
                            >
                              <input
                                type="file"
                                className="InputsFile"
                                id="qpath"
                                name="qpath"
                                onChange={handlechange}
                                placeholder="Enter question path"
                                required
                              />
                            </div>
                            {fdata.qpath !== "" && fdata.qpath !== null && (
                              <div
                                className={
                                  "col-md-9 d-flex align-content-center p-0"
                                }
                              >
                                <span className="nn_upload_file">
                                  {fdata.qpath !== "" && fdata.qpath !== null
                                    ? fdata.original_que_paper_filepath
                                    : ""}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                        {error.qpath && (
                          <small className="error">{error.qpath}</small>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="forms ">
                        <label htmlFor="inputName" className="form-label  ">
                          Cut-off
                        </label>
                        <input
                          type="number"
                          class="Inputs"
                          id="cut_off"
                          value={fdata.cut_off < 0 ? 0 : fdata.cut_off}
                          name="cut_off"
                          placeholder="Enter Cut-off Mark"
                          onChange={handlechange}
                        />
                        {error.cut_off && (
                          <small className="error">{error.cut_off}</small>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}

          {/* ---Descriptive Type (Question Paper Upload)---- */}
          {type === "0" && (
            <section className="global_container">
              <div className="row m-0">
                <fieldset>
                  <legend
                    className="w-auto"
                    style={{ fontSize: "16px", padding: "0px 10px" }}
                  >
                    Question Paper
                  </legend>
                  <div class="row">
                    <div class="col-12">
                      <form className="row g-3">
                        <div class="col-md-6 ">
                          <div className="d-flex">
                            <div className="row">
                              <label
                                for="formFile"
                                class={` form-label confirm_value m-0 m-0`}
                              >
                                Question Paper
                              </label>
                            </div>
                            {fdata.questionPath !== "" &&
                              fdata.questionPath !== null && (
                                <div
                                  className={"d-flex align-content-center p-0"}
                                >
                                  {fdata.questionPath !== "" &&
                                    fdata.questionPath !== null && (
                                      <>
                                        <a
                                          target="_blank"
                                          href={`${ImageUrlPrefix}/${fdata.questionPath}`}
                                          // style={{ marginTop: "15px" }}
                                        >
                                          <Download className="download_icon" />
                                        </a>
                                      </>
                                    )}
                                </div>
                              )}
                          </div>
                          {/* <input
                            type="file"
                            // class={`${styles.desc_input} w-100 opacity-75 rounded-2 input-font-size-sm`}
                            className={
                              fdata.questionPath !== "" &&
                                fdata.questionPath !== null
                                ? "InputsFile nn_upload_width"
                                : "InputsFile  vv_upload_width"
                            }

                            id="questionPath"
                            name="questionPath"
                            onChange={handleFileChange}
                            placeholder="Enter question path"
                            required
                          /> */}

                          {/* {fdata.questionPath !== "" &&
                            fdata.questionPath !== null && (
                              <div
                                className={
                                  "col-md-g d-flex align-content-center p-0"
                                }
                              >
                                <span className="nn_upload_widthFile">
                                  {fdata.questionPath !== "" &&
                                    fdata.questionPath !== null
                                    ? fdata.original_que_paper_filepath
                                    : ""}
                                </span>
                              </div>
                            )} */}

                          <div className="row">
                            <div
                              className={
                                fdata.questionPath !== "" &&
                                fdata.questionPath !== null
                                  ? "col-md-3 "
                                  : "col-md-12"
                              }
                            >
                              <input
                                id="questionPath"
                                type="file"
                                name="questionPath"
                                placeholder="Upload Question Paper"
                                className={
                                  fdata.questionPath !== "" &&
                                  fdata.questionPath !== null
                                    ? "InputsSelectFile nn_upload_width"
                                    : "InputsSelectFile  vv_upload_width"
                                }
                                onChange={(e) => handleFileChange(e)} // Ensure the function is correctly referenced
                                autoComplete="questionPath"
                                required
                              />
                            </div>
                            {console.log(
                              fdata.questionPath,
                              "fdata.questionPath"
                            )}
                            {fdata.questionPath !== "" &&
                              fdata.questionPath !== null && (
                                <div
                                  className={
                                    "col-md-9 col-7 d-flex align-content-center p-0"
                                  }
                                >
                                  <span className="nn_upload_fileevaluator">
                                    {fdata.questionPath !== "" &&
                                    fdata.questionPath !== null
                                      ? fdata.question_paper_original_path
                                      : ""}
                                  </span>
                                  {fdata.questionPath !== "" &&
                                    fdata.questionPath !== null && (
                                      <>
                                        <span
                                          className={`${styles.verified_uploadeval} material-icons align-middle text-danger`}
                                        >
                                          verified
                                        </span>
                                      </>
                                    )}
                                </div>
                              )}
                          </div>
                          {error.questionPath && (
                            <small
                              className="error "
                              style={{ marginLeft: "0px" }}
                            >
                              {error.questionPath}
                            </small>
                          )}
                          <Box
                            sx={{
                              display: isUploading ? "flex" : "none",
                              justifyContent: "center",
                              alignItems: "center",
                              position: "fixed",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              backgroundColor: "white",
                              zIndex: 999,
                            }}
                          >
                            {" "}
                            {/* Set width here */}
                            {/* <LinearProgress variant="determinate" value={progress} /> */}
                            {isUploading && (
                              <ProgressLoader progress={progress} />
                            )}
                          </Box>
                        </div>

                        <div class="col-md-6 ">
                          <div className="d-flex">
                            <div className="row">
                              <label
                                for="formFile"
                                class={` form-label confirm_value m-0`}
                              >
                                Answer Booklet
                              </label>
                            </div>
                            {fdata.AnswerBookletPath !== "" &&
                              fdata.AnswerBookletPath !== null && (
                                <div
                                  className={"d-flex align-content-center p-0"}
                                >
                                  {fdata.AnswerBookletPath !== "" &&
                                    fdata.AnswerBookletPath !== null && (
                                      <>
                                        <a
                                          target="_blank"
                                          href={`${ImageUrlPrefix}/${fdata.AnswerBookletPath}`}
                                          // style={{ marginTop: "15px" }}
                                        >
                                          <Download className="download_icon" />
                                        </a>
                                      </>
                                    )}
                                </div>
                              )}
                          </div>
                          <div className="row">
                            <div
                              className={
                                fdata.AnswerBookletPath !== "" &&
                                fdata.AnswerBookletPath !== null
                                  ? "col-md-3 "
                                  : "col-md-12"
                              }
                            >
                              <input
                                id="AnswerBookletPath"
                                type="file"
                                name="AnswerBookletPath"
                                placeholder="Upload Question Paper"
                                className={
                                  fdata.AnswerBookletPath !== "" &&
                                  fdata.AnswerBookletPath !== null
                                    ? "InputsSelectFile nn_upload_width"
                                    : "InputsSelectFile  vv_upload_width"
                                }
                                onChange={(e) => handleFileChange(e)} // Ensure the function is correctly referenced
                                autoComplete="AnswerBookletPath"
                                required
                              />
                            </div>
                            {fdata.AnswerBookletPath !== "" &&
                              fdata.AnswerBookletPath !== null && (
                                <div
                                  className={
                                    "col-md-9 d-flex align-content-center p-0"
                                  }
                                >
                                  <span className="nn_upload_fileevaluator">
                                    {fdata.AnswerBookletPath !== "" &&
                                    fdata.AnswerBookletPath !== null
                                      ? fdata.answer_booklet_original_path
                                      : ""}
                                  </span>
                                  {fdata.AnswerBookletPath !== "" &&
                                    fdata.AnswerBookletPath !== null && (
                                      <>
                                        <span
                                          className={`${styles.verified_uploadeval} material-icons align-middle text-danger`}
                                        >
                                          verified
                                        </span>
                                      </>
                                    )}
                                </div>
                              )}
                          </div>
                          {error.AnswerBookletPath && (
                            <small
                              className="error"
                              style={{ marginLeft: "0px" }}
                            >
                              {error.AnswerBookletPath}
                            </small>
                          )}
                        </div>

                        <div class="col-md-6 ">
                          <div className="d-flex">
                            <div className="row">
                              <label
                                for="formFile"
                                class={` form-label confirm_value m-0`}
                              >
                                Question Frame Set
                              </label>
                            </div>
                            {fdata.questionFrameSetPath !== "" &&
                              fdata.questionFrameSetPath !== null && (
                                <div
                                  className={"d-flex align-content-center p-0"}
                                >
                                  {fdata.questionFrameSetPath !== "" &&
                                    fdata.questionFrameSetPath !== null && (
                                      <>
                                        <a
                                          target="_blank"
                                          href={`${ImageUrlPrefix}/${fdata.questionFrameSetPath}`}
                                          // style={{ marginTop: "15px" }}
                                        >
                                          <Download className="download_icon" />
                                        </a>
                                      </>
                                    )}
                                </div>
                              )}
                          </div>

                          <div className="row">
                            <div
                              className={
                                fdata.questionFrameSetPath !== "" &&
                                fdata.questionFrameSetPath !== null
                                  ? "col-md-3 "
                                  : "col-md-12"
                              }
                            >
                              <input
                                id="questionFrameSetPath"
                                type="file"
                                name="questionFrameSetPath"
                                placeholder="Upload Question Paper"
                                className={
                                  fdata.questionFrameSetPath !== "" &&
                                  fdata.questionFrameSetPath !== null
                                    ? "InputsSelectFile nn_upload_width"
                                    : "InputsSelectFile  vv_upload_width"
                                }
                                onChange={(e) => handleFileChange(e)} // Ensure the function is correctly referenced
                                autoComplete="questionFrameSetPath"
                                required
                              />
                            </div>
                            {fdata.questionFrameSetPath !== "" &&
                              fdata.questionFrameSetPath !== null && (
                                <div
                                  className={
                                    "col-md-9 d-flex align-content-center p-0"
                                  }
                                >
                                  <span className="nn_upload_fileevaluator">
                                    {fdata.questionFrameSetPath !== "" &&
                                    fdata.questionFrameSetPath !== null
                                      ? fdata.question_frame_original_path
                                      : ""}
                                  </span>
                                  {fdata.questionFrameSetPath !== "" &&
                                    fdata.questionFrameSetPath !== null && (
                                      <>
                                        <span
                                          className={`${styles.verified_uploadeval} material-icons align-middle text-danger`}
                                        >
                                          verified
                                        </span>
                                      </>
                                    )}
                                </div>
                              )}
                          </div>
                          {error.questionFrameSetPath && (
                            <small className="error">
                              {error.questionFrameSetPath}
                            </small>
                          )}
                        </div>

                        <div class="col-md-6 ">
                          <div className="d-flex">
                            <div className="row">
                              <label
                                for="formFile"
                                class={` form-label confirm_value m-0`}
                              >
                                Answer Key
                              </label>
                            </div>
                            {fdata.AnswerKeyPath !== "" &&
                              fdata.AnswerKeyPath !== null && (
                                <div
                                  className={"d-flex align-content-center p-0"}
                                >
                                  {fdata.AnswerKeyPath !== "" &&
                                    fdata.AnswerKeyPath !== null && (
                                      <>
                                        <a
                                          target="_blank"
                                          href={`${ImageUrlPrefix}/${fdata.AnswerKeyPath}`}
                                          // style={{ marginTop: "15px" }}
                                        >
                                          <Download className="download_icon" />
                                        </a>
                                      </>
                                    )}
                                </div>
                              )}
                          </div>

                          <div className="row">
                            <div
                              className={
                                fdata.AnswerKeyPath !== "" &&
                                fdata.AnswerKeyPath !== null
                                  ? "col-md-3 "
                                  : "col-md-12"
                              }
                            >
                              <input
                                id="AnswerKeyPath"
                                type="file"
                                name="AnswerKeyPath"
                                placeholder="Upload Question Paper"
                                className={
                                  fdata.AnswerKeyPath !== "" &&
                                  fdata.AnswerKeyPath !== null
                                    ? "InputsSelectFile nn_upload_width"
                                    : "InputsSelectFile  vv_upload_width"
                                }
                                onChange={(e) => handleFileChange(e)} // Ensure the function is correctly referenced
                                autoComplete="AnswerKeyPath"
                                required
                              />
                            </div>
                            {fdata.AnswerKeyPath !== "" &&
                              fdata.AnswerKeyPath !== null && (
                                <div
                                  className={
                                    "col-md-9 d-flex align-content-center p-0"
                                  }
                                >
                                  <span className="nn_upload_fileevaluator">
                                    {fdata.AnswerKeyPath !== "" &&
                                    fdata.AnswerKeyPath !== null
                                      ? fdata.answer_key_original_path
                                      : ""}
                                  </span>
                                  {fdata.AnswerKeyPath !== "" &&
                                    fdata.AnswerKeyPath !== null && (
                                      <>
                                        <span
                                          className={`${styles.verified_uploadeval} material-icons align-middle text-danger`}
                                        >
                                          verified
                                        </span>
                                      </>
                                    )}
                                </div>
                              )}
                          </div>

                          {error.AnswerKeyPath && (
                            <small className="error">
                              {error.AnswerKeyPath}
                            </small>
                          )}
                        </div>
                        <div class="col-md-6">
                          <label
                            for="Cut-off"
                            class="form-label confirm_value m-0 "
                          >
                            Cut-off
                          </label>
                          <input
                            type="number"
                            id="cut_off"
                            class={`${styles.border_head_color} form-control form-control-sm shadow-none input-font-size`}
                            value={fdata.cut_off < 0 ? 0 : fdata.cut_off}
                            name="cut_off"
                            placeholder="Enter Cut-off Mark"
                            onChange={handleFileChange}
                          />
                          {error.cut_off && (
                            <small className="error">{error.cut_off}</small>
                          )}
                        </div>
                        <div className="col-md-6">
                          <label
                            htmlFor="doubleEvaluation"
                            className={`${styles.form_label} confirm_value`}
                          >
                            Double Evaluation
                          </label>
                          <div className="mt-2">
                            <input
                              // ref={txtEventDownloadAnswerSheet}
                              className={styles.checkbox_radio}
                              type="radio"
                              name="doubleEvaluation"
                              id="doubleEvaluation"
                              value="1"
                              checked={fdata.doubleEvaluation === 1}
                              onChange={handleFileChange}
                            />
                            <label
                              className={`${styles.margin_right} form-label confirm_value`}
                              htmlFor="YesDAnswersheet"
                            >
                              Yes
                            </label>
                            {console.log(
                              fdata.doubleEvaluation === 1,
                              "doubleEvaluation"
                            )}
                            <input
                              className={styles.checkbox_radio}
                              type="radio"
                              name="doubleEvaluation"
                              id="doubleEvaluation"
                              value="0"
                              checked={fdata.doubleEvaluation === 0}
                              onChange={handleFileChange}
                            />
                            <label
                              className="form-label confirm_value"
                              htmlFor="NoDAnswersheet"
                            >
                              No
                            </label>
                          </div>
                          {error.doubleEvaluation && (
                            <small className="error">
                              {error.doubleEvaluation}
                            </small>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                </fieldset>
              </div>
            </section>
          )}
          <div className="heading me-4 mt-3 d-flex justify-content-end ">
            <Link to="/TestList" className="CancelButton">
              Back to View Test
            </Link>
            <button
              type="button"
              className="detailEventButton"
              onClick={type === "1" ? handleUpload_objective : handleUpload}
            >
              Save Question Paper
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
